import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next'; // Import useTranslation
import style from "./index.module.scss";
import cn from "classnames";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import ToggleSwitchYes from "../../shared/icons/ToggleSwitchYes";
import ToggleSwitchNo from "../../shared/icons/ToggleSwitchNo";
import CustomInput from "../../custom/custom-input/CustomInput";
import OrdersDocumentCard from "../../orders/orders-documents/OrdersDocumentCard";
import CloseIconNew from "../../shared/icons/CloseIconNew";
import DocumentIcon from "../../shared/icons/DocumentIcon";

const CargoInsurance = ({
  defaultValue = false,
  onClick,
  declaredPrice = '',
  setDeclaredPrice,
  fileInvoice,
  setInvoiceFile,
  detect,
}) => {
  const { t } = useTranslation(); // Instantiate the hook
  const getFile = (event) => {
    setInvoiceFile(event);
    if (detect) detect();
  };


  useEffect(() => {
    console.log("[defaultValue]===", defaultValue);
  }, [defaultValue]);

  return (
    <div
      className={cn(style.wrapper, style.borderBottom)}
      style={{ paddingBottom: "16px" }}
    >
      <div className={style.checkbox_wrapper}>
        <div className={style.checkbox_content}>
          <p>{t('cargoInsurance.enableInsurance')}</p>
          <span>{t('cargoInsurance.insuranceCostInfo')}</span>
        </div>
        <div className={cn(style.switch)} onClick={() => onClick(!defaultValue)}>
          {defaultValue ? <ToggleSwitchYes /> : <ToggleSwitchNo />}
        </div>
      </div>

      {defaultValue && (
        <div className={style.invoice_wrapper}>
          <OrdersSectionItemInfoColumn title={t('cargoInsurance.declaredValueTitle')} style={{ flex: 1 }}>
            <div>
              <CustomInput
                inputType={"text"}
                placeholder="0"
                isBgGray
                prefixEnd="₸"
                value={declaredPrice || ''}
                onChangeValue={(item) => {
                  const numericValue = item.replace(/\D/g, '');
                  if (numericValue !== '0') {
                    setDeclaredPrice(numericValue);
                    if (detect) detect();
                  } else if (numericValue === '' || numericValue === null) {
                    setDeclaredPrice('');
                    if (detect) detect();
                  }
                }}
              />
            </div>
          </OrdersSectionItemInfoColumn>

          {!fileInvoice?.name && (
            <OrdersSectionItemInfoColumn title={t('cargoInsurance.invoiceTitleOptional')}>
              <div className={style.btnUpload}>
                <OrdersDocumentCard
                  key={"fileInvoice-add"}
                  isAddButton
                  text={t('cargoInsurance.uploadInvoiceButton')}
                  onUploadFile={getFile}
                />
              </div>
            </OrdersSectionItemInfoColumn>
          )}

          {fileInvoice?.name && (
            <div className={cn(style.documentCard, style.cardItem)}>
              <DocumentIcon className={style.documentCard_icon} />
              <span className={style.documentCard_text}>{fileInvoice?.name}</span>
              <span className={style.documentCard_close}>
                <CloseIconNew
                  width={16}
                  height={16}
                  onClick={() => setInvoiceFile(null)}
                  fill={"#909195"}
                />
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CargoInsurance;
